// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Cleaning",
    laundry: "Laundry",
    maintenance: "Maintenance & repairs",
    supplies: "Supplies & amenities",
    utilities: "Utilities",
    staff: "Staff",
    software: "Software & tools",
    marketing: "Marketing",
    taxes: "Taxes & fees",
    other: "Other",
  },

  restricted: "Management expenses are only visible to the main account: your access is limited to some properties.",

  summary: {
    aria: "Expense summary for the period. Select a figure to filter the table.",
    total: "Total expenses",
    count: "{n} expense | {n} expenses",
    charged: "Charged to owners",
    chargedHint: "Deducted from their statements",
    own: "Own expenses",
    ownHint: "Deducted from your profit",
  },

  toolbar: {
    search: "Search",
    searchPlaceholder: "Description or supplier",
    clearSearch: "Clear search",
    category: "Category",
    allCategories: "All",
    listing: "Property",
    allListings: "All",
    type: "Type",
    allTypes: "All",
    charged: "Charged to owner",
    own: "Own expenses",
    create: "New expense",
  },

  table: {
    date: "Date",
    category: "Category",
    concept: "Description",
    listing: "Property",
    chargedTo: "Charged to",
    amount: "Amount",
    receipt: "Receipt",
    actions: "Actions",
    general: "General",
    management: "Management",
    ownerMissing: "No owner assigned",
    notCharged: "This property is no longer managed: nobody is charged for it",
    vat: "VAT {pct}%",
    download: "Download receipt",
    edit: "Edit",
    remove: "Delete",
  },

  empty: {
    title: "No expenses in this period",
    text: "Log what you pay (cleaning, laundry, repairs, software…) and decide whether it's charged to the owner or is your own expense.",
    create: "Add an expense",
    filteredTitle: "No expenses match the filters",
    filteredText: "Try a different search or clear the filters to see every expense in the period.",
    clear: "Clear filters",
  },

  load: {
    error: "Expenses couldn't be loaded.",
    retry: "Try again",
  },

  remove: {
    title: "Delete this expense?",
    message: "“{concept}” ({amount}) will no longer count in analytics or owner statements.",
    confirm: "Delete",
    done: "Expense deleted",
    error: "The expense couldn't be deleted. Please try again.",
  },

  receiptError: "The receipt couldn't be downloaded.",

  drawer: {
    newTitle: "New expense",
    editTitle: "Edit expense",
    newSubtitle: "What you pay to run the properties, charged to the owner or to your management company.",
    editSubtitle: "Changes show up right away in analytics and owner statements.",
    close: "Close",
    sections: {
      expense: "The expense",
      listing: "Property and owner",
      notes: "Notes",
      receipt: "Receipt or invoice",
    },
    fields: {
      concept: "Description",
      conceptPlaceholder: "E.g. Check-out cleaning",
      category: "Category",
      date: "Date",
      supplier: "Supplier",
      supplierPlaceholder: "E.g. Sunshine Laundry",
      amount: "Amount",
      vat: "VAT",
      vatHint: "For reference only: the amount is what you paid, VAT included.",
      listing: "Property",
      listingGeneral: "General management expense (no property)",
      unit: "Unit",
      unitAll: "Whole property",
      notesPlaceholder: "Any detail you want to remember",
    },
    charge: {
      label: "Charge to the owner",
      general: "A general expense always belongs to your management company. Choose a property to charge it to its owner.",
      loading: "Checking the property…",
      error: "We couldn't check whether this property is managed.",
      retry: "Try again",
      notManaged: "This property isn't marked as managed: the expense counts as your own.",
      notManagedMarked: "This property is no longer managed: nobody is charged for it. Turn this off to keep it as your own expense.",
      own: "If you don't charge it, it counts as your own expense.",
      owner: "It will be deducted from {owner}'s statement.",
      noOwner: "This property has no owner assigned yet: it will be deducted from the statement of whoever you assign.",
    },
    receipt: {
      drop: "Drag the photo or PDF here",
      pick: "or choose a file",
      formats: "JPG, PNG, WEBP, HEIC or PDF · max. 10 MB",
      current: "Saved receipt",
      download: "Download",
      change: "Replace",
      remove: "Remove",
      undo: "Undo",
      willRemove: "The receipt will be removed when you save.",
      willReplace: "replaces the saved one",
      tooBig: "The file is larger than 10 MB.",
      badType: "Unsupported format: upload a photo (JPG, PNG, WEBP or HEIC) or a PDF.",
    },
    errors: {
      required: "This field is required.",
      category: "Choose a category.",
      amount: "Enter an amount greater than 0.",
      vat: "Enter a percentage between 0 and 100.",
      review: "Please check the highlighted fields.",
      generic: "The expense couldn't be saved. Please try again.",
    },
    discard: {
      title: "Discard changes?",
      message: "What you've entered for this expense will be lost.",
      confirm: "Discard",
      cancel: "Keep editing",
    },
    cancel: "Cancel",
    save: "Save expense",
    saveChanges: "Save changes",
    saving: "Saving…",
    created: "Expense saved",
    updated: "Changes saved",
    outOfPeriod: "Saved. Its date ({date}) is outside the period you're viewing.",
  },
};
